export const wetenschap = [
  "Zwaartekracht",
  "DNA",
  "Evolutie",
  "Einstein",
  "Newton",
  "Relativiteitstheorie",
  "Kwantummechanica",
  "Atomen",
  "Moleculen",
  "Elektriciteit",
  "Magnetisme",
  "Energie",
  "Zonne-energie",
  "Kernenergie",
  "Raket",
  "Robotica",
  "Kunstmatige intelligentie",
  "Nanotechnologie",
  "Biotechnologie",
  "Genetica",
  "Microbiologie",
  "Big Bang",
  "Higgs-deeltje",
  "Zwarte gaten",
  "Ruimtevaart",
  "Telescoop",
  "Microscoop",
  "Chemie",
  "Fysica",
  "Biologie",
  "Astronomie",
  "Geneeskunde",
  "Ingenieurswetenschappen",
  "Computerwetenschappen",
  "Programmeren",
  "Algoritme",
  "Datastructuur",
  "Netwerk",
  "Internet",
  "Cybersecurity",
  "Kunstmatige intelligentie",
  "Machine learning",
  "Cryptografie",
  "Blockchain",
  "Virtual reality",
  "Augmented reality",
  "3D-printen",
  "Drones",
  "Gentherapie",
  "Stamcellen",
  "Vaccinatie",
  "Robotchirurgie",
  "Biomedische technologie",
  "Quantumcomputers",
  "Grafische kaart",
  "Cloud computing",
  "Internet der dingen",
  "Biometrie",
  "Röntgenstraling",
  "Laser",
  "GPS",
  "Telecommunicatie",
  "Satelliet",
  "Foton",
  "Elektron",
  "Proton",
  "Neutron",
  "Grafene",
  "Supergeleiding",
  "Antibiotica",
  "RNA",
  "Elektromagnetisme",
  "Radiogolven",
  "Microgolven",
  "Infraroodstraling",
  "Ultraviolet licht",
  "Röntgenstraling",
  "Gammastraling",
  "Elektronenmicroscoop",
  "Kernfusie",
  "Kernsplijting",
  "Optica",
  "Astrofysica",
  "Natuurkunde",
  "Quantumfysica",
  "Organische chemie",
  "Anorganische chemie",
  "Thermodynamica",
  "Biomoleculen",
  "Koolstofdioxide",
  "Waterstof",
  "Zuurstof",
  "Stikstof",
  "DNA-sequencing",
  "Genetische modificatie",
  "CRISPR",
  "Biologische diversiteit",
  "Ecologie",
  "Klimaatverandering",
  "Duurzame energie",
  "Windenergie",
  "Zonne-energie",
  "Brandstofcel",
  "Kunststof",
  "Glasvezel",
  "Halfgeleiders",
  "Transistor",
  "Geleidbaarheid",
  "Quantummechanica",
  "Schrodingers kat",
  "Radioactiviteit",
  "Kernstraling",
  "Magnetische resonantie",
  "Fotovoltaïsche cellen",
  "Enzymen",
  "Katalyse",
  "Hydrolyse",
  "RNA-interferentie",
  "Neurologie",
  "Psychologie",
  "Sociologie",
  "Antropologie",
  "Archeologie",
  "Paleontologie",
  "Robot",
  "Exoplaneten",
  "Kepler-telescoop",
  "Hubble-telescoop",
  "Saturnus",
  "Mars",
  "Neptunus",
  "Zwarte gaten",
  "Kernfusie",
  "CERN",
  "Stephen Hawking",
  "Marie Curie",
  "Isaac Newton",
  "Albert Einstein",
  "Nikola Tesla",
  "Leonardo da Vinci",
  "Charles Darwin",
  "Alexander Graham Bell",
  "Thomas Edison",
  "Galileo Galilei",
  "Ada Lovelace",
  "Alan Turing",
  "Steve Jobs",
  "Bill Gates",
  "Elon Musk",
  "Mark Zuckerberg",
  "Tim Berners-Lee",
  "Grace Hopper",
  "Rosie the Riveter",
  "Marie Van Brittan Brown",
  "Guglielmo Marconi",
  "James Watt",
  "Benjamin Franklin",
  "Louis Pasteur",
  "Jane Goodall",
  "Rachel Carson",
  "Robert Koch",
  "Ernest Rutherford",
  "Alexander Fleming",
  "Rosalind Franklin",
  "Max Planck",
  "Fritz Haber",
  "Enrico Fermi",
  "Jonas Salk",
  "Werner Heisenberg",
  "Edwin Hubble",
  "Niels Bohr",
  "Carl Sagan",
  "Hans Geiger",
  "Marie-Joseph Lagrange",
  "Alfred Nobel",
  "Erwin Schrödinger",
  "Edmund Halley",
  "Jacques Cousteau",
  "Richard Feynman",
  "Antonie van Leeuwenhoek",
  "Aristoteles",
  "Archimedes",
  "Hippocrates",
  "Leonardo Fibonacci",
  "Nicolaus Copernicus",
  "Johannes Kepler",
  "Robert Hooke",
  "Antoine Lavoisier",
  "Joseph Priestley",
  "John Dalton",
  "James Clerk Maxwell",
  "Dmitri Mendeleev",
  "Ernest Rutherford",
  "Max Planck",
  "Albert Einstein",
  "Werner Heisenberg",
  "Neils Bohr",
  "Marie Curie",
  "Ada Lovelace",
  "Alan Turing",
  "Grace Hopper",
  "Isaac Newton",
  "Galileo Galilei",
  "Nikola Tesla",
  "Thomas Edison",
  "Alexander Graham Bell",
  "Charles Babbage",
  "Wilhelm Conrad Röntgen",
  "Guglielmo Marconi",
  "Karl Benz",
  "Louis Pasteur",
  "Robert Koch",
  "Florence Nightingale",
  "Edwin Hubble",
  "Stephen Hawking",
  "Rachel Carson",
  "Jane Goodall",
  "Albert Hofmann",
  "Rosalind Franklin",
  "Jonas Salk",
  "Frits Zernike",
  "Francis Crick",
];
